import { render, staticRenderFns } from "./ActivatePage.vue?vue&type=template&id=dbe84b1c&scoped=true&"
import script from "./ActivatePage.vue?vue&type=script&lang=js&"
export * from "./ActivatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe84b1c",
  null
  
)

export default component.exports